// Import only what you need from Turf
import difference from '@turf/difference';
import toTurf from './toTurf.js';
import fromTurf from './fromTurf.js';
import GeoJSON from 'ol/format/GeoJSON';

export default function getDifferenceTurf(feat1, feat2, mapProjection) {
  const formatGeo = new GeoJSON();
  const lastInTurf = toTurf(feat1, mapProjection, formatGeo);
  const nowInTurf = toTurf(feat2, mapProjection, formatGeo);

  let differences = difference(nowInTurf, lastInTurf);
  let differences1 = difference(lastInTurf, nowInTurf);

  if (differences !== null) {
    differences = fromTurf(differences, mapProjection, formatGeo);
  }
  if (differences1 !== null) {
    differences1 = fromTurf(differences1, mapProjection, formatGeo);
  }

  return [differences, differences1];
};
